import React, { useReducer, useMemo, useEffect, useState, useCallback, useLayoutEffect, useContext } from 'react'
import { getBoard, getForm, getTriggerAction, getEntity, getReader, syncQueryString, getObjectValue, getActionListOuterData, isValid } from './utils'
import { useLocation, useHistory, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import { useAlert } from 'react-alert'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { withCookies } from 'react-cookie';
import { driver } from "driver.js";
import "driver.js/dist/driver.css";

import Event from './event'
import Reader from './reader'
import Board from './board'
import Form from './form'
import { DataContext, modalAlertContext } from '../../app';
import { eventAlertContext } from '../layout';
import Print from '../print';
import { reducer, observerReducer, actionReducer, actionProcessor } from './index.reducer';
import useCommon, { mergeCommon, useAppHistory } from './useCommon';
import useStoredMemo from './useStoredMemo';

const driverObj = driver();
const emptyObj = {}
const emptyArr = []

const Header = ({ title = "Portal Iguala", processing, processingLabel = "", backHandle = null }) => (
	<div className="col mb-2">
		<Helmet>
			<title>{`${title} - Iguala`}</title>
		</Helmet>
		{backHandle ? <button onClick={backHandle} className='border btn btn-light rounded-circle align-baseline mr-2' title='Regresar'><FontAwesomeIcon icon={["fas", "arrow-left"]} /></button> : null}
		<h1 className="d-inline mx-1 ">{title}</h1>
		{processing && (
			<div className='d-inline ml-1'>
				<span><FontAwesomeIcon icon={["fas", "cog"]} spin size="sm" /></span>
				{processingLabel && <span className="ml-2 badge badge-secondary">{processingLabel}</span>}
			</div>
		)}
	</div>
)

const closeNoop = () => { }

const ActiveForm = ({ active, i, forms, dispatch, data, DisplayBoard, entity }) => {

	const props = forms.find((form) => form.name === active.name && (form.type === "card" || form.type === "modal"))

	const closefn = useCallback(() => {
		dispatch({ type: "close-form", index: i });
		return { closed: true }
	}, [dispatch, i])

	return props &&
		<Form
			key={i}
			path={`forms.${i}`}
			processingFlagPath={`forms.${i}.processing`}
			processing={active.processing}
			data={active.data}
			reset={active.reset}
			pageData={data}
			struct={entity[active.entity || props.entity]}
			{...props}
			DisplayBoard={DisplayBoard}
			title={active.title || props.title}
			closefn={closefn}
		/>
}

const Page = ({
	title,
	entity: entityList = [],
	reader: configReaders = [],
	board: configBoards = [],
	form: configForms = [],
	action,
	data: configData,
	setup,
	refresh,
	cookies,
	isInnerPage = false
}) => {
	//console.log("spam")
	const context = useContext(DataContext);

	const [data, dispatch] = useReducer(reducer, mergeCommon((configData && JSON.parse(configData)) || {}, context.common))
	const [, observerDispatch] = useReducer(observerReducer, {})
	const [actions, actionDispatch] = useReducer(actionReducer, { main: [] });

	const alert = useAlert(modalAlertContext);
	const event = useAlert(eventAlertContext);
	const {
		push: historyPush,
		replace: historyReplace,
		go: historyGo
	} = useHistory()

	const {
		search: locationSearch,
		pathname: locationPath
	} = useLocation()

	const urlParams = JSON.stringify(useParams());
	const [currentScope] = useStoredMemo(context?.scope?.current);
	const [currentMeta] = useStoredMemo(data.meta);
	const [currentQuery] = useStoredMemo(data.query);
	const contextDispatch = context.dispatch;

	useCommon(data.common, context.common, dispatch, contextDispatch, isInnerPage)

	useEffect(() => {
		return () => {
			observerDispatch({ type: "dettach-all" });
		}
	}, []);

	useEffect(() => {
		dispatch({
			type: "set-meta",
			payload: {
				scope: currentScope,
				params: JSON.parse(urlParams),
				location: {
					search: locationSearch,
					path: locationPath
				},
				history: {
					push: historyPush,
					replace: historyReplace,
					go: historyGo
				},
				tour: driverObj,
				alert: alert.show,
				event: event.show,
				eventRemove: event.remove,
				refresh: () => { contextDispatch({ type: "refresh-data", payload: true }) },
				refreshed: () => { contextDispatch({ type: "refreshed" }) },
				run: (actions = [], data = {}, close = closeNoop, processingFlagPath = "", thread) => {
					if (processingFlagPath) dispatch({ type: "set-data", path: processingFlagPath, payload: actions.length });
					actionDispatch({ type: "add", thread, actions: { tasks: actions, data, close, processingFlagPath } })
				},
				actionDispatch,
				observerDispatch,
				cookies
			}
		});
	}, [contextDispatch, locationSearch, locationPath, historyPush, historyReplace, historyGo, alert, event, currentScope, cookies, urlParams])

	const [init, setInit] = useState(false);


	useEffect(() => {
		if (currentMeta && !init) {
			setInit(true);
			const pageData = (configData && JSON.parse(configData)) || {}
			console.log("initializing", currentMeta, pageData);

			if (pageData.inner && !isInnerPage) {
				console.warn("página interna no disponible como principal");
				currentMeta.history.replace('/')
			} else {
				getTriggerAction({
					actionNames: setup,
					meta: currentMeta
				})()()
			}

		}
	}, [setup, init, configData, currentMeta, isInnerPage])

	const [neededData] = useStoredMemo(useMemo(() => {
		const queryObj = currentQuery instanceof Object ? currentQuery : {}
		let newNeeded = getActionListOuterData(action, data)[0];

		newNeeded = Object.values(queryObj)
			.filter(path => !newNeeded[path])
			.reduce((obj, path) => ({ ...obj, [path]: getObjectValue(data, path) }), newNeeded)

		return newNeeded;
	}, [action, currentQuery, data]))

	const properties = useMemo(() => ({
		dispatch: dispatch,
		meta: currentMeta,
		query: currentQuery,
		scope: currentScope
	}), [dispatch, currentMeta, currentScope, currentQuery])

	useLayoutEffect(() => {
		syncQueryString({ ...properties, outerData: neededData });
	}, [properties, neededData])

	const [processing, setThreadProcessing] = useState({ main: false });
	const anyProcessing = Object.entries(processing).some(([k, v]) => v || !!actions[k].length)

	const setProcessing = useCallback((processing, thread) => setThreadProcessing(state => ({ ...state, [thread || 'main']: processing })), [])
	const currentAction = useMemo(() => Object.keys(actions).reduce((obj, key) => ({ ...obj, [key]: actions[key][0] }), {}), [actions]);

	// MARK: ACCIONES
	useEffect(() => {
		Object.entries(currentAction).forEach(([thread, currentAction]) => {
			actionProcessor({
				currentAction,
				thread,
				processing: processing[thread],
				anyProcessing,
				action,
				actionDispatch,
				setProcessing,
				dispatch,
				data,
				currentMeta,
				currentScope
			})()
		})

		if (!anyProcessing && (data._local || data._processing)) {
			console.log('cleaning _local')
			dispatch({ type: "set-data", path: "_local", payload: null, autocreate: false })
			dispatch({ type: "set-data", path: "_processing", payload: null, autocreate: false })
		}
	}, [processing, anyProcessing, currentAction, setProcessing, currentScope, data, dispatch, currentMeta, action])


	const entity = useMemo(() => getEntity(entityList), [entityList]);
	const forms = useMemo(() => getForm(configForms, title, properties), [configForms, title, properties])
	const readers = useMemo(() => properties.meta ? getReader(configReaders, properties, data) : [], [configReaders, properties, data])
	const boards = useMemo(() => properties.meta ? getBoard(configBoards, entity, properties) : [], [configBoards, entity, properties])

	//eleva al app el refresh disparado por action.
	useEffect(() => {
		if (data.refresh) {
			dispatch({ type: "set-data", path: "refresh", payload: false })
			context.dispatch({ type: "refresh-data", payload: true })
		}
	}, [context, data.refresh])

	useEffect(() => {
		if (context.shouldRefresh && refresh) {
			contextDispatch({ type: "refreshing" })
			getTriggerAction({
				actionNames: refresh.concat(";refreshed"),
				meta: currentMeta
			})()()
		}
	}, [refresh, contextDispatch, context.shouldRefresh, currentMeta])

	const formHeader = forms.find(form => form.type === "header")
	const activeForms = (data.forms instanceof Array) ? data.forms : emptyArr
	const hiddenBoards = (data.hidden instanceof Array) ? data.hidden : emptyArr
	const filteredBoards = (typeof data.filtered === 'object') ? data.filtered : emptyObj

	const contextRefreshing = !!context?.refreshing

	useLayoutEffect(() => {
		if (contextRefreshing !== data._refreshing) {
			dispatch({ type: "set-data", path: "_refreshing", payload: contextRefreshing })
		}
	}, [data._refreshing, contextRefreshing])

	// useEffect(() => {
	// 	window.DisplayBoardDeps = (window.DisplayBoardDeps || 0) + 1
	// }, [filteredBoards, contextRefreshing, currentMeta, data, boards])

	const DisplayBoard = useCallback(({ boardName, ...props }) => {
		const board = boards.find(({ name }) => name === boardName)

		return board
			? <Board key={board.name}
				//hidden={hiddenBoards.includes(board.name)}
				filtered={filteredBoards[board.name]}
				data={data}
				{...props}
				{...board}
				meta={currentMeta}
				dispatch={dispatch}
				refreshing={contextRefreshing}
			/>
			: <span>{`Board ${boardName} not defined.`}</span>
	}, [filteredBoards, contextRefreshing, currentMeta, data, boards])

	const backHandle = useAppHistory(locationPath, context.history, contextDispatch, isInnerPage);

	const formHeaderTitle = data.header?.title || formHeader?.title || title
	const processingLabel = !isValid(data._processing) ? null : typeof data._processing === 'string' ? data._processing : Object.values(data._processing).find(v => typeof v === "string")
	const isProcessing = processing.main || !!processingLabel
	const FormHeader = useCallback(() => (<Header title={formHeaderTitle} processing={isProcessing} processingLabel={processingLabel} backHandle={backHandle} />), [formHeaderTitle, isProcessing, processingLabel, backHandle])

	return (
		<React.Fragment>
			{
				isInnerPage && !formHeader ? null :
					<div className={isInnerPage ? "content-header-inner" : "content-header"} >
						{formHeader
							? <Form
								Header={isInnerPage ? null : FormHeader}
								path="header"
								processingFlagPath="header.processing"
								processing={data.header?.processing}
								data={data.header?.data}
								pageData={data}
								struct={entity[data.header?.entity || formHeader.entity]}
								{...formHeader}
								DisplayBoard={DisplayBoard}
							/>
							: <section className="container-fluid">
								<div className="row">
									<Header title={title} processing={isProcessing} processingLabel={processingLabel} backHandle={backHandle} />
								</div>
							</section>
						}
					</div>
			}
			<div className={`content ${isInnerPage ? "content-inner" : "content-main"}`}>
				<section className="container-fluid">
					{
						activeForms.map(((active, i) => !active ? null : <ActiveForm key={`page-form-${i}`} entity={entity} active={active} i={i} forms={forms} dispatch={dispatch} DisplayBoard={DisplayBoard} data={data} />))
					}
					{readers.map((reader) => <Reader key={reader.name} {...reader} data={data} context={context} />)}
					{
						boards.map((board) =>
							<Board key={board.name}
								hidden={hiddenBoards.includes(board.name)}
								filtered={filteredBoards[board.name]}
								data={data}
								{...board}
								meta={currentMeta}
								dispatch={dispatch}
								refreshing={context && context.refreshing}
							/>)
					}
					<Event data={data} processing={anyProcessing} init={init} locationSearch={locationSearch} action={useCallback(() => setInit(false), [])} />
					<Print context={context} {...(data.print)} dispatch={dispatch} />
				</section>
			</div>
		</React.Fragment>
	)
}

export default withCookies(Page)
